// Module
var code = "<template>\n <i class=\"icon-${icon}\"></i>\n</template>\n";
// Exports
export default code;